export class Forca {
    id?: number = -1;
    nome: string = "";
    sigla: string = "";
    cor: string = "";
    emailAsplan?: string = "";
    icone?: string = "";
    brasao?: string = "";
}